import { ARROW_DOWN, ARROW_UP, HOME, END } from "./keys.js";

/**
 * Arrow key handler for a toggle button that opens a menu.
 * Calls open(target) with the item that should receive focus once the menu is open.
 *
 * @param {KeyboardEvent} e
 * @param {{ items: Element[], open: (target: Element) => void }} options
 */
export function handleToggleArrowKeys(e, { items, open }) {
  if (!items.length) return;
  switch (e.key) {
    case ARROW_DOWN:
      e.preventDefault();
      open(items[0]);
      break;
    case ARROW_UP:
      e.preventDefault();
      open(items[items.length - 1]);
      break;
  }
}

/**
 * Arrow key handler for navigating within an open menu.
 * ArrowDown always stops at the last item. ArrowUp from the first item either
 * wraps to the last item (wrap: true) or returns focus to the toggle (default).
 *
 * @param {KeyboardEvent} e
 * @param {{ toggle: Element, items: Element[], wrap?: boolean }} options
 */
export function handleMenuArrowKeys(e, { toggle, items, wrap = false }) {
  const index = items.indexOf(document.activeElement);
  if (index === -1) return;

  switch (e.key) {
    case ARROW_DOWN:
      e.preventDefault();
      items[index + 1]?.focus();
      break;
    case ARROW_UP:
      e.preventDefault();
      if (index > 0) {
        items[index - 1].focus();
      } else if (wrap) {
        items[items.length - 1].focus();
      } else {
        toggle.focus();
      }
      break;
    case HOME:
      e.preventDefault();
      items[0].focus();
      break;
    case END:
      e.preventDefault();
      items[items.length - 1].focus();
      break;
  }
}
